module.exports = __webpack_public_path__ + "img/title1.3f5e443d.png";